if (!customElements.get('push-product-card')) {
  class PushProductCard extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.handleResize.bind(this);
      this.tryInit = this.tryInit.bind(this);
      this.resizeTimeout = null;
      this.initAttempt = 0;
      this.initialized = false;
    }

    connectedCallback() {
      this.tryInit();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.resizeTimeout);
      this.initialized = false;
      this.initAttempt = 0;
    }

    tryInit() {
      if (this.initialized) return;

      this.image = this.querySelector('.product__push-product-image');
      this.content = this.querySelector('.product__push-product-content');

      if (!this.image || !this.content) {
        if (this.initAttempt < 20) {
          this.initAttempt += 1;
          window.requestAnimationFrame(this.tryInit);
        }
        return;
      }

      this.initialized = true;
      this.updateImageWidth();
      window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
      window.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(() => this.updateImageWidth(), 120);
    }

    updateImageWidth() {
      if (!this.image || !this.content) return;

      if (window.innerWidth <= 749) {
        this.image.style.removeProperty('--push-product-image-width');
        return;
      }

      const ratio = 4 / 5;
      const containerWidth = this.getBoundingClientRect().width;
      const minWidth = 92;
      const maxWidth = Math.min(220, containerWidth * 0.42);
      const clamp = (value) => Math.max(minWidth, Math.min(maxWidth, value));
      let width =
        parseFloat(this.image.style.getPropertyValue('--push-product-image-width')) || this.image.getBoundingClientRect().width || minWidth;
      width = clamp(width);

      // Resolve width/height dependency in a fixed number of sync passes.
      for (let index = 0; index < 4; index += 1) {
        this.image.style.setProperty('--push-product-image-width', `${width}px`);

        const contentHeight = this.content.getBoundingClientRect().height;
        if (!contentHeight) return;

        const nextWidth = clamp(contentHeight * ratio);
        if (Math.abs(nextWidth - width) < 0.5) {
          width = nextWidth;
          break;
        }

        width = nextWidth;
      }

      this.image.style.setProperty('--push-product-image-width', `${width}px`);
    }
  }

  customElements.define('push-product-card', PushProductCard);
}
